/**
 * Return a value formatted into currency.
 *
 * @param {string|number|integer} value
 *   The value to format.
 *
 * @return {string}
 *   The formatted value.
 */
export const currencyFormat = (value) => {
    let currency = value;
    if (typeof value !== 'string') {
        currency = `${value}`;
    }
    return currency.replace(/(\d)(?=((\d){3})+(?:\.\d+)*$)/g, '$1.');
};
/**
 * Get a parameter from the query.
 *
 * @param {string} parameterName
 *
 * @returns null|string
 */
export const getParameter = (parameterName) => {
    const items = window.location.search.substr(1).split('&');
    for (let index = 0; index < items.length; index += 1) {
        const tmp = items[index].split('=');
        if (tmp[0] === parameterName) {
            return decodeURIComponent(tmp[1]);
        }
    }
    return null;
};
